import type { SxProps, Theme } from '@mui/material/styles';

import { signupPageStyles, signupTypography } from '../../../pages/signup/SignupPage/SignupPage.styles';

export const signupHeaderStyles = {
  logoHeader: signupPageStyles.logoHeader,
  logo: signupPageStyles.logo,
  title: signupPageStyles.title,
  accentLink: signupPageStyles.accentLink,
  productLogo: (): SxProps<Theme> => ({
    display: 'block',
    width: { xs: '190px', sm: '230px' },
    height: { xs: '120px', sm: '145px' },
    objectFit: 'contain',
  }),
  intro: (isCentered = false): SxProps<Theme> => ({
    width: '100%',
    maxWidth: isCentered ? '620px' : '720px',
    mx: 'auto',
    mt: { xs: 2, sm: 2.5 },
    mb: { xs: 3, md: 3.5 },
    textAlign: isCentered ? 'center' : 'left',
  }),
  subtitle: (theme: Theme): SxProps<Theme> => ({
    mt: 1,
    color: theme.palette.grey[700],
    fontSize: signupTypography.standard,
  }),
};
